import { render, staticRenderFns } from "./ProjectAdmin.vue?vue&type=template&id=46558630&scoped=true&"
import script from "./ProjectAdmin.vue?vue&type=script&lang=js&"
export * from "./ProjectAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAdmin.vue?vue&type=style&index=0&id=46558630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46558630",
  null
  
)

export default component.exports